/* Carusel Before/After + scroll ancore. Fara dependinte externe. */
(function () {
  function init(root) {
    var targets = [];
    if (root && root.matches && root.matches('.landing-cromatica-v2')) targets.push(root);
    if (root && root.querySelectorAll) targets.push.apply(targets, root.querySelectorAll('.landing-cromatica-v2'));
    targets.forEach(function (landing) {
      if (landing.dataset.lcInitialized === '1') return;
      landing.dataset.lcInitialized = '1';
      landing.querySelectorAll('[data-carousel]').forEach(function (carousel) {
        var track = carousel.querySelector('.case-track');
        if (!track) return;
        var cards = Array.prototype.slice.call(track.querySelectorAll('.case-card'));
        var dots = Array.prototype.slice.call(carousel.querySelectorAll('.case-dot'));
        if (!cards.length) return;
        var index = 0;
        function updateDots() {
          dots.forEach(function (dot, i) {
            dot.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        }
        function goTo(next) {
          index = (next + cards.length) % cards.length;
          var offset = cards[index].offsetLeft - cards[0].offsetLeft;
          track.scrollTo({ left: offset, behavior: 'smooth' });
          updateDots();
        }
        var prev = carousel.querySelector('.case-prev');
        var next = carousel.querySelector('.case-next');
        if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
        if (next) next.addEventListener('click', function () { goTo(index + 1); });
        dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () { goTo(i); });
        });
        var timer;
        track.addEventListener('scroll', function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            var closest = 0;
            var best = Infinity;
            cards.forEach(function (card, i) {
              var distance = Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft);
              if (distance < best) { best = distance; closest = i; }
            });
            index = closest;
            updateDots();
          }, 90);
        }, { passive: true });
      });
      landing.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          var id = link.getAttribute('href').slice(1);
          if (!id) return;
          var target = landing.querySelector('[id="' + id.replace(/[^a-zA-Z0-9_-]/g, '') + '"]');
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
